import React, { useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from './TabPanel';

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    key: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '15px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.palette.shadow.light,
    height: '100%',
    borderRadius: '10px'
  },
  rooScrollable: {
    height: '100%',
  },
  tabs: {
    boxShadow: theme.palette.shadow.main,

    '& .MuiTabs-indicator': {
      height: 4,
    },
  },
  tab: {
    ...theme.typography.h4,
    textTransform: 'uppercase',
    flexDirection: 'row',
    alignItems: 'flex-start',
    opacity: 0.2
  },
  tabSelected: {
    fontWeight: '800',
    color: '#474747f0'
  },
}));

function CustomTabs3(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
    tabs,
    tabContents,
    toolbar,
    variant,
    disabled,
    tabDisabled,
    handleChangeTab,
    activeTab,
    textColor,
    scrollable,
    defaultTab
  } = props;

  const [value, setValue] = useState(defaultTab?defaultTab:0);
  const handleChange = (event, newValue) => {
    if (newValue === tabs.length) {
      return;
    }
    setValue(newValue);
    handleChangeTab(newValue);
  };

  if (tabs.length > 0 && value >= tabs.length) {
    setValue(tabs.length - 1);
  }

  const tabValue = activeTab > -1 ? activeTab : value;

  return (
    <div className={scrollable ? classes.rooScrollable : classes.root}>
      <Tabs
        className={classes.tabs}
        textColor={textColor ? textColor : 'inherit'}
        
        value={disabled ? false : tabValue}
        onChange={handleChange}
        TabIndicatorProps={{
          style: {
            display: 'none',
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            className={classnames(classes.tab, index === tabValue && classes.tabSelected)}
            label={tab}
            {...a11yProps(index)}
            disabled={disabled || tabDisabled.indexOf(index) > -1}
          />
        ))}
        {toolbar && (
          <Tab className={classes.tab} label={toolbar} />
        )}
      </Tabs>

      {tabContents.map((content, index) => (
        <>
        { index === tabValue &&
          <TabPanel
            scrollable={scrollable}
            value={tabValue}
            index={index}
            dir={theme.direction}
            key={`tab_panel_${index}`}
          >
            {content}
          </TabPanel>
      }</>
      ))} 
    </div>
  );
}

CustomTabs3.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabContents: PropTypes.array.isRequired,
  toolbar: PropTypes.array,
  disabled: PropTypes.bool,
  tabDisabled: PropTypes.array,
  variant: PropTypes.string,
  handleChangeTab: PropTypes.func,
  activeTab: PropTypes.number,
};

CustomTabs3.defaultProps = {
  disabled: false,
  tabDisabled: [],
  toolbar: undefined,
  variant: undefined,
  handleChangeTab: () => null,
  activeTab: undefined,
};

export default CustomTabs3;
